// extracted by mini-css-extract-plugin
module.exports = {"appearTime":"300ms","Tutorial":"Tutorial_Tutorial__2VUcs","HintShow":"Tutorial_HintShow__3BW8v","Hint":"Tutorial_Hint__3mc_T"};